import { motion } from "framer-motion";
import { ChevronDown, FileDown, MapPin, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import mainLogo from "@/assets/main-logo.svg";
import heroTexture from "@/assets/pastaluna-hero-ravioli-texture.jpg";

const HeroSection = () => {
  return (
    <section
      className="relative min-h-[100svh] flex items-center justify-center overflow-hidden"
    >
      {/* Texture image docked to left */}
      <div className="absolute left-0 top-0 bottom-0 w-[40%] md:w-[35%] lg:w-[30%] pointer-events-none z-0">
        <img
          src={heroTexture}
          alt="טקסטורת רקע של בצק רביולי טרי - PastaLuna"
          aria-hidden="true"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-background via-background/90 to-background/50" />
      </div>


      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-4 md:mb-6 flex justify-center"
        >
          <img src={mainLogo} alt="PastaLuna" className="w-[85vw] sm:w-[75vw] md:w-[65vw] lg:w-[55vw] xl:w-[50vw] max-w-[900px] h-auto" />
        </motion.div>

        <motion.p
          className="font-handwriting text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-muted-foreground mb-6 md:mb-10 max-w-lg mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          איכות בוטיק איטלקית לכל סגנון חיים.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex justify-center"
        >
          <div className="bg-white/70 backdrop-blur-sm rounded-3xl shadow-xl px-6 py-6 sm:px-8 sm:py-7 max-w-xl w-full">
            <h2 className="font-display font-black text-2xl sm:text-3xl text-foreground text-center mb-4">
              צרו קשר
            </h2>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.dispatchEvent(new CustomEvent("set-contact-type", { detail: "business" }));
                  setTimeout(() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }), 50);
                }}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-pl-blue text-white font-display font-bold text-sm sm:text-base hover:opacity-90 transition-all shadow-md whitespace-nowrap"
              >
                <FileDown className="w-4 h-4 sm:w-5 sm:h-5" />
                קטלוג לעסקים
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.dispatchEvent(new CustomEvent("set-contact-type", { detail: "private" }));
                  setTimeout(() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }), 50);
                }}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-pl-green text-white font-display font-bold text-sm sm:text-base hover:opacity-90 transition-all shadow-md whitespace-nowrap"
              >
                <UserRound className="w-4 h-4 sm:w-5 sm:h-5" />
                לקוחות פרטיים
              </a>
              <Link
                to="/where-to-buy"
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-pl-yellow text-pl-black font-display font-bold text-sm sm:text-base hover:opacity-90 transition-all shadow-md whitespace-nowrap"
              >
                <MapPin className="w-4 h-4 sm:w-5 sm:h-5" />
                לרכישה
              </Link>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-4 md:mt-6"
        >
          <SocialLinks className="justify-center" iconClassName="w-5 h-5 sm:w-6 sm:h-6" />
        </motion.div>

      </div>

      {/* Scroll down indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 cursor-pointer"
        onClick={() => document.querySelector('#dietary')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <span className="text-foreground/60 font-display font-bold text-sm sm:text-base tracking-wide">גלול למטה</span>
        <motion.div
          animate={{ y: [0, 12, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <ChevronDown className="w-8 h-8 sm:w-10 sm:h-10 text-foreground/60" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
